import { render } from "./ProfileReport.vue?vue&type=template&id=f37bce0e&scoped=true"
import script from "./ProfileReport.vue?vue&type=script&lang=js"
export * from "./ProfileReport.vue?vue&type=script&lang=js"

import "./ProfileReport.vue?vue&type=style&index=0&id=f37bce0e&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37bce0e"]])

export default __exports__